import { ReactNode } from 'react';
import { usePermission } from '../../hooks/usePermission';
import { NavItem } from './NavItems';

interface NavbarPermissionGuardProps {
  /**
   * The navigation item to check permissions for
   */
  item: NavItem & {
    requiredPermissions?: string[];
    adminOnly?: boolean;
  };
  /**
   * The content to render if the user has permission
   */
  children: ReactNode;
}

/**
 * Component that conditionally renders navigation items based on user permissions
 */
export function NavbarPermissionGuard({
  item,
  children,
}: NavbarPermissionGuardProps) {
  const { hasAnyPermission } = usePermission();

  // If no permissions are required, always show the item
  if (!item.requiredPermissions || item.requiredPermissions.length === 0) {
    return <>{children}</>;
  }

  // Only show the item if the user has any of the required permissions
  return hasAnyPermission(item.requiredPermissions) ? <>{children}</> : null;
}
